export default __webpack_public_path__ + "static/media/pauseGreen.6c1536a6.svg";